import { z } from 'zod'

export type ApiCode = number | string

export const SUCCESS_CODE = '00000'
export const LEGACY_SUCCESS_CODE = 200

export const isSuccessCode = (code: ApiCode) =>
  code === SUCCESS_CODE ||
  code === LEGACY_SUCCESS_CODE ||
  code === String(LEGACY_SUCCESS_CODE)

export const ApiCodeSchema = z.union([z.string(), z.number()])

export const ResultSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z
    .object({
      code: ApiCodeSchema,
      msg: z.string().optional(),
      message: z.string().optional(),
      data: dataSchema,
    })
    .transform((value) => ({
      code: value.code,
      message: value.msg ?? value.message ?? '',
      data: value.data,
    }))

export const PageResultSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    total: z.number(),
    size: z.number(),
    current: z.number(),
    pages: z.number(),
    records: z.array(itemSchema),
  })

export type PageResult<T> = {
  total: number
  size: number
  current: number
  pages: number
  records: T[]
}
